import { defineAsyncComponent } from 'vue';

const SettingLayout = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/views/common/SettingLayout.vue'),
);

const CopyVoucherPopup = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/views/common/CopyVoucherPopup.vue'),
);
const DeleteErrorPopup = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/views/common/DeleteErrorPopup.vue'),
);

const NPSForm = defineAsyncComponent(() => import('@/views/common/NPSForm.vue'));

const ImportExcel = defineAsyncComponent(() => import('@/views/common/import/ImportExcel.vue'));
const ConvertTT23 = defineAsyncComponent(() => import('@/views/common/circulars/ConvertTT23.vue'));

const ImportInfo = defineAsyncComponent(() => import('@/views/common/import/ImportInfoPopup.vue'));
//Popup hiển thị hướng dẫn các phím tắt trong chương trình màn detail
const ShortkeyDetailPopup = defineAsyncComponent(() => import('@/views/common/ShortkeyDetailPopup.vue'));
//Popup hiển thị hướng dẫn các phím tắt trong chương trình màn danh sách, danh mục
const ShortkeyListPopup = defineAsyncComponent(() => import('@/views/common/ShortkeyListPopup.vue'));
//Popup bảo trì dữ liệu
const DataMaintainancePopup = defineAsyncComponent(() => import('@/views/common/DataMaintainancePopup.vue'));

const ConfirmRedirectPopup = defineAsyncComponent(() => import('@/views/common/ConfirmRedirectPopup.vue'));

const LocalQuickSearchPopup = defineAsyncComponent(() => import('@/views/common/LocalQuickSearchPopup.vue'));

const RemoteQuickSearchPopup = defineAsyncComponent(() => import('@/views/common/RemoteQuickSearchPopup.vue'));

const SettingPrint = defineAsyncComponent(() => import('@/views/common/SettingPrint.vue'));

const ChooseVoucherReportSettingBuPlanWithDraw = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportSettingBuPlanWithDraw.vue'),
);
const ChooseVoucherReportSettingBuTransfer = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportSettingBuTransfer.vue'),
);
const ChooseVoucherReportCAReceiptPlanWithdrawList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportCAReceiptPlanWithdrawList.vue'),
);
const ChooseVoucherReportCAReceiptList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportCAReceiptList.vue'),
);
const ChooseVoucherReportCAPayment = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportCAPayment.vue'),
);
const ChooseVoucherReportBADepositTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportBADepositTab.vue'),
);
const ChooseVoucherReportBAWithdrawTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportBAWithdrawTab.vue'),
);
const ChooseVoucherReportBABankTransferTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportBABankTransferTab.vue'),
);
const ChooseVoucherReportINInwardTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportINInwardTab.vue'),
);
const ChooseVoucherReportInOutwardList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportInOutwardList.vue'),
);
const ChooseVoucherReportINTransferList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportINTransferList.vue'),
);
const ChooseVoucherINAdjustmentList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherINAdjustmentList.vue'),
);
const ChooseVoucherFADevaluationList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherFADevaluationList.vue'),
);
const ChooseVoucherFADecrementList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherFADecrementList.vue'),
);
const ChooseVoucherReportSAInvoiceTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportSAInvoiceTab.vue'),
);
const ChooseVoucherReportSAReturnList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportSAReturnList.vue'),
);
const ChooseVoucherGLVoucherTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherGLVoucherTab.vue'),
);
const ChoosevoucherReportBATransferTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChoosevoucherReportBATransferTab.vue'),
);
const ChooseVoucherReportBUCommitmentRequestTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportBUCommitmentRequestTab.vue'),
);
const ChooseVoucherReportBUCommitmentAdjustmentTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportBUCommitmentAdjustmentTab.vue'),
);
const ChooseVoucherReportBUPlanCancelTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportBUPlanCancelTab.vue'),
);
const ChooseVoucherReportGLPostedTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportGLPostedTab.vue'),
);
const ChooseVoucherReportGLProfitLossTransferTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportGLProfitLossTransferTab.vue'),
);
const ChooseVoucherReportGLEndYearTransferTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportGLEndYearTransferTab.vue'),
);
const ChooseVoucherReportGLBeginningYearTransferTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportGLBeginningYearTransferTab.vue'),
);
const ChooseVoucherFAIncrementList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherFAIncrementList.vue'),
);
const ChooseVoucherFAPurchaseIncrementList = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherFAPurchaseIncrementList.vue'),
);
const ChooseVoucherReportBUPlanReceiptTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportBUPlanReceiptTab.vue'),
);
// Chứng từ gốc chưa thanh toán hết
const SelectRefNoInvoicePopup = defineAsyncComponent(() => import('@/views/common/SelectRefNoInvoicePopup.vue'));

const ChooseVoucherReportFixedAssetAdjustment = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportFixedAssetAdjustment.vue'),
);
const ChooseVoucherBUPlanAdjustmentTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherBUPlanAdjustmentTab.vue'),
);
const ChooseVoucherReportFADepreciation = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportFADepreciation.vue'),
);
const ChooseVoucherReportCAReceiptFixedAsset = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportCAReceiptFixedAsset.vue'),
);
const ChooseVoucherReportGLVoucherSummaryTable = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportGLVoucherSummaryTable.vue'),
);
const ChooseVoucherReportQLTSVoucher = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportQLTSVoucher.vue'),
);
const ChooseVoucherReportGLPayrollExpenseTab = defineAsyncComponent(() =>
  import('@/views/common/reportSetting/ChooseVoucherReportGLPayrollExpenseTab.vue'),
);
const ViewAdvanceBalance = defineAsyncComponent(() =>
  import('@/views/common/ViewAdvanceBalance.vue'),
);
const UpdateTT23Popup = defineAsyncComponent(() =>
  import('@/views/common/UpdateTT23Popup.vue'),
);
const UpdateTT76Popup = defineAsyncComponent(() =>
  import('@/views/common/UpdateTT76Popup.vue'),
);
const DictionaryHideSetting = defineAsyncComponent(() =>
  import('@/views/common/DictionaryHideSettingPopup.vue'),
);
const VoucherReference = defineAsyncComponent(() =>
  import('@/views/common/VoucherReference.vue'),
);
const ConfirmChangeTTPopup = defineAsyncComponent(() =>
  import('@/views/common/ConfirmChangeTTPopup.vue'),
);
const NotifyUpdateTT24 = defineAsyncComponent(() =>
  import('@/views/common/NotifyUpdateTT24.vue'),
);

const NotifyOffline = defineAsyncComponent(() =>
  import('@/components/pwa/NotifyOffline.vue'),
);

const MaintainPopup = defineAsyncComponent(() =>
  import('@/views/common/MaintainPopup.vue'),
);

const ChooseMethodGettingPopup = defineAsyncComponent(() =>
  import('@/views/system/ChooseMethodGettingPopup.vue'),
);
const BannerHelpConvertDataPopup = defineAsyncComponent(() => import('@/views/common/BannerHelpConvertDataPopup.vue'));

const ShowConfirmEstimate = defineAsyncComponent(() => import('@/views/common/ShowConfirmEstimate.vue'));

const DeleteRelationPopup = defineAsyncComponent(() =>
  import('@/views/common/DeleteRelationPopup.vue'),
);

const EmailConfigPopup = defineAsyncComponent(() => 
  import('@/views/common/EmailConfig.vue')
);

const PrivacyPolicyPopup = defineAsyncComponent(() =>
  import('@/views/common/PrivacyPolicyPopup.vue')
);

export function registerCommonPopup(app) {
  app.component('SettingLayout', SettingLayout);
  app.component('CopyVoucherPopup', CopyVoucherPopup);
  app.component('DeleteRelationPopup', DeleteRelationPopup);
  app.component('ImportExcel', ImportExcel);
  app.component('ConvertTT23', ConvertTT23);
  app.component('ImportInfo', ImportInfo);
  app.component('ShortkeyDetailPopup', ShortkeyDetailPopup);
  app.component('ShortkeyListPopup', ShortkeyListPopup);
  app.component('DataMaintainancePopup', DataMaintainancePopup);
  app.component('ConfirmRedirectPopup', ConfirmRedirectPopup);
  app.component('LocalQuickSearchPopup', LocalQuickSearchPopup);
  app.component('RemoteQuickSearchPopup', RemoteQuickSearchPopup);
  app.component('SettingPrint', SettingPrint);
  app.component('ChooseVoucherReportSettingBuPlanWithDraw', ChooseVoucherReportSettingBuPlanWithDraw);
  app.component('ChooseVoucherReportSettingBuTransfer', ChooseVoucherReportSettingBuTransfer);
  app.component('ChooseVoucherReportCAReceiptPlanWithdrawList', ChooseVoucherReportCAReceiptPlanWithdrawList);
  app.component('ChooseVoucherReportCAReceiptList', ChooseVoucherReportCAReceiptList);
  app.component('ChooseVoucherReportCAPayment', ChooseVoucherReportCAPayment);
  app.component('ChooseVoucherReportBAWithdrawTab', ChooseVoucherReportBAWithdrawTab);
  app.component('ChooseVoucherReportBABankTransferTab', ChooseVoucherReportBABankTransferTab);
  app.component('ChooseVoucherReportInOutwardList', ChooseVoucherReportInOutwardList);
  app.component('ChooseVoucherReportINTransferList', ChooseVoucherReportINTransferList);
  app.component('ChooseVoucherINAdjustmentList', ChooseVoucherINAdjustmentList);
  app.component('ChooseVoucherFADevaluationList', ChooseVoucherFADevaluationList);
  app.component('ChooseVoucherFADecrementList', ChooseVoucherFADecrementList);
  app.component('ChooseVoucherReportBADepositTab', ChooseVoucherReportBADepositTab);
  app.component('ChooseVoucherReportSAInvoiceTab', ChooseVoucherReportSAInvoiceTab);
  app.component('ChooseVoucherReportSAReturnList', ChooseVoucherReportSAReturnList);
  app.component('ChooseVoucherGLVoucherTab', ChooseVoucherGLVoucherTab);
  app.component('ChoosevoucherReportBATransferTab', ChoosevoucherReportBATransferTab);
  app.component('ChooseVoucherReportBUCommitmentRequestTab', ChooseVoucherReportBUCommitmentRequestTab);
  app.component('ChooseVoucherReportBUCommitmentAdjustmentTab', ChooseVoucherReportBUCommitmentAdjustmentTab);
  app.component('ChooseVoucherReportBUPlanCancelTab', ChooseVoucherReportBUPlanCancelTab);
  app.component('ChooseVoucherReportGLPostedTab', ChooseVoucherReportGLPostedTab);
  app.component('ChooseVoucherReportGLProfitLossTransferTab', ChooseVoucherReportGLProfitLossTransferTab);
  app.component('ChooseVoucherReportGLEndYearTransferTab', ChooseVoucherReportGLEndYearTransferTab);
  app.component('ChooseVoucherReportGLBeginningYearTransferTab', ChooseVoucherReportGLBeginningYearTransferTab);
  app.component('ChooseVoucherReportFixedAssetAdjustment', ChooseVoucherReportFixedAssetAdjustment);
  app.component('ChooseVoucherFAIncrementList', ChooseVoucherFAIncrementList);
  app.component('ChooseVoucherFAPurchaseIncrementList', ChooseVoucherFAPurchaseIncrementList);
  app.component('SelectRefNoInvoicePopup', SelectRefNoInvoicePopup);
  app.component('ChooseVoucherBUPlanAdjustmentTab', ChooseVoucherBUPlanAdjustmentTab);
  app.component('ChooseVoucherReportINInwardTab', ChooseVoucherReportINInwardTab);
  app.component('ChooseVoucherReportFADepreciation', ChooseVoucherReportFADepreciation);
  app.component('ChooseVoucherReportCAReceiptFixedAsset', ChooseVoucherReportCAReceiptFixedAsset);
  app.component('ChooseVoucherReportGLVoucherSummaryTable', ChooseVoucherReportGLVoucherSummaryTable);
  app.component('ChooseVoucherReportBUPlanReceiptTab', ChooseVoucherReportBUPlanReceiptTab);
  app.component('ChooseVoucherReportQLTSVoucher', ChooseVoucherReportQLTSVoucher);
  app.component('ChooseVoucherReportGLPayrollExpenseTab', ChooseVoucherReportGLPayrollExpenseTab);
  app.component('ViewAdvanceBalance', ViewAdvanceBalance);
  app.component('UpdateTT23Popup', UpdateTT23Popup);
  app.component('UpdateTT76Popup', UpdateTT76Popup);
  app.component('DictionaryHideSetting', DictionaryHideSetting);
  app.component('VoucherReference', VoucherReference);
  app.component('ConfirmChangeTTPopup', ConfirmChangeTTPopup);
  app.component('NotifyUpdateTT24', NotifyUpdateTT24);
  app.component('NotifyOffline', NotifyOffline);
  app.component('MaintainPopup', MaintainPopup);
  app.component('ChooseMethodGettingPopup', ChooseMethodGettingPopup);
  app.component('BannerHelpConvertDataPopup', BannerHelpConvertDataPopup);
  app.component('ShowConfirmEstimate', ShowConfirmEstimate);
  app.component('DeleteErrorPopup', DeleteErrorPopup);
  app.component('EmailConfigPopup', EmailConfigPopup);
  app.component('NPSForm', NPSForm);
  app.component('PrivacyPolicyPopup', PrivacyPolicyPopup);
}
